/**
 *  Creates a version of name that is unique amongst existing
 *
 *  foo, [foo] => foo-copy
 */

export const copyName = (name: string, existing: string[]) => {
  // remove existing -copy-x suffix that may exist
  const baseName = name.replace(/(-copy(-[0-9]+)?)?$/, '')

  // search existing fields that start with this name
  const regex = RegExp(`^${baseName}`)
  const others = existing.filter(e => e.match(regex))
  if (others.length > 0) {
    for (let c = 1; c <= 1000; c++) {
      const rename = c === 1 ? `${baseName}-copy` : `${baseName}-copy-${c}`
      const found = others.find(s => s === rename)
      if (!found) {
        return rename
      }
    }
  }
  return name
}
